export default __webpack_public_path__ + "static/link-light.png";